import { render, staticRenderFns } from "./PostEdit.vue?vue&type=template&id=f5c124fc&scoped=true&lang=pug&"
import script from "./PostEdit.vue?vue&type=script&lang=js&"
export * from "./PostEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c124fc",
  null
  
)

export default component.exports